/** Textes « notes » — le français fait foi. */
export const notes = {
  erreurChargement: "Les notes n'ont pas pu être chargées.",
  erreurEnregistrement: "La note n'a pas pu être enregistrée.",
  neSAffichentPas: "Les notes ne s'affichent pas",
  titre: 'Notes',
  compte: (n: number) => `${n} note(s)`,
  vousEcrivez: ' · vous écrivez ici',
  vousLisez: ' · écrites par le responsable, vous les lisez',
  ecrire: 'Écrire une note',
  rienNote: 'Rien de noté pour le moment',
  responsableRien: "Le responsable n'a rien noté",
  nePlusEpingler: 'Ne plus épingler',
  epinglerEnHaut: 'Épingler en haut',
  epinglee: 'Épinglée',
  epingler: 'Épingler',
  modifier: 'Modifier',
  supprimer: 'Supprimer',
  vide: '— vide —',
  modifieeLe: (d: string) => `modifiée le ${d}`,
  modifierNote: 'Modifier la note',
  titreChamp: 'Titre',
  titreExemple: 'Ex. : renégocier le tarif Medtrans',
  note: 'Note',
  noteExemple: 'Ce que vous ne voulez pas oublier.',
  annuler: 'Annuler',
  enregistrer: 'Enregistrer',
  supprimerTitre: (t: string) => `Supprimer « ${t} » ?`,
  supprimerTexte: 'La note disparaît définitivement. Le journal gardera la trace de la suppression, pas le texte.',
};
